import { validateSlideForExport } from './validateCarouselForExport';
import type { QuoteSlide } from './types';

export type SlideDownloadGate = 'ready' | 'awaiting_frame' | 'empty_text';

/**
 * "Baixar imagem" for one slide: refused without text (the ZIP's text gate),
 * held while that slide's frame is still going to be captured
 * (`capturePending` = the capture hook will run), otherwise ready — a slide
 * whose capture will never run renders with the fallback background, exactly
 * as the ZIP would.
 */
export function resolveSlideDownloadGate(args: {
  slide: QuoteSlide;
  capturePending: boolean;
}): SlideDownloadGate {
  const { slide, capturePending } = args;
  if (validateSlideForExport(slide).ok === false) return 'empty_text';
  if (capturePending && slide.background?.kind === 'frame' && slide.background.url === null) {
    return 'awaiting_frame';
  }
  return 'ready';
}
